import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

export default function SectionLoader() {
  return (
    <div className="w-full py-16 px-4 bg-slate-50/50 flex flex-col items-center justify-center min-h-[300px] rounded-3xl border border-slate-100 relative overflow-hidden">
      {/* Subtle Shimmer Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-slate-100/50 to-transparent animate-shimmer -translate-x-full" 
           style={{ backgroundSize: '200% 100%' }} />

      <div className="relative z-10 flex flex-col items-center gap-4 text-center">
        <motion.div 
          animate={{ rotate: 360 }}
          transition={{ duration: 2.5, repeat: Infinity, ease: "linear" }}
          className="w-12 h-12 rounded-2xl bg-brand-accent/10 border border-brand-accent/20 flex items-center justify-center text-brand-accent"
        >
          <Sparkles size={18} className="animate-pulse" />
        </motion.div>
        
        <div className="space-y-2">
          <div className="h-4 bg-slate-200/80 rounded-full w-24 mx-auto animate-pulse" />
          <div className="h-3 bg-slate-200/50 rounded-full w-40 mx-auto animate-pulse" />
        </div>
      </div>
    </div>
  );
}
